export const getHeaders = (
  accessToken?: string,
  method?: string,
  url?: string,
): Record<string, string> => {
  if (accessToken) {
    if (method === 'POST' && url?.includes('messages')) {
      return {
        Authorization: `Bearer ${accessToken}`,
      };
    }

    if (method === 'POST' && url?.includes('download')) {
      return {
        'Content-Type': 'application/pdf',
        'Authorization': `Bearer ${accessToken}`,
      };
    }

    if (method === 'PATCH' && url?.includes('reassign-agent')) {
      return {
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/plain, */*',
        'X-Source-System': `deuna:webapp`,
        'Authorization': `Bearer ${accessToken}`,
      };
    }

    return {
      'Content-Type': 'application/json',
      'Accept': 'application/json, text/plain, */*',
      'Authorization': `Bearer ${accessToken}`,
    };
  }

  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json, text/plain, */*',
  };
};
